import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isAdmin", "isStoreKeeper", "isAffiliate"]),
    platforms() {
      return [
        {
          title: "Admin Eleven",
          active: true,
          value: "admin_eleven",
          user_type: "admin",
          topics: [
            {
              title: this.$t("help-center.overview"),
              value: "visao_geral_admin",
            },
            {
              title: this.$t("eleven-dashboard.title"),
              value: "eleven_dashboard",
            },
            {
              title: this.$t("producer-dashboard.title"),
              value: "produtor_dashboard",
            },
            {
              title: this.$t("digital-wallet.title"),
              value: "carteira_digital",
            },
            {
              title: this.$t("reports.title"),
              value: "relatorios",
              subtopics: [
                {
                  title: this.$t("reports.general-sales.title"),
                  value: "vendas_gerais",
                },
                {
                  title: this.$t("reports.financial-producer.title"),
                  value: "financeiro_produtor",
                },
                {
                  title: this.$t("reports.nf-consumer.title"),
                  value: "nf_consumidor_final",
                },
                {
                  title: this.$t("reports.detailed-sale"),
                  value: "venda_detalhada",
                },
                {
                  title: this.$t("reports.products-sales.title"),
                  value: "venda_produtos",
                },
                {
                  title: this.$t("reports.sales-with-protect.title"),
                  value: "venda_protect",
                },
                {
                  title: this.$t("reports.eleven.financial"),
                  value: "financeiro_eleventickets",
                },
                {
                  title: this.$t("reports.eleven.consumers"),
                  value: "consumidores_eleventickets",
                },
              ],
            },
            {
              title: this.$t("registrations.title"),
              value: "cadastros",
              subtopics: [
                {
                  title: this.$t("registrations.producers.title"),
                  value: "produtores",
                },
                {
                  title: this.$t("registrations.segment.title"),
                  value: "segmentos",
                },
                {
                  title: this.$t("registrations.users.title"),
                  value: "usuarios",
                },
                {
                  title: this.$t("registrations.payment-rules.title"),
                  value: "regras_pagamento",
                },
                {
                  title: this.$t("registrations.integrations.title"),
                  value: "integracoes",
                },
              ],
            },
            {
              title: this.$t("reports.point-of-sale.title"),
              value: "pontos_venda",
              subtopics: [
                { title: this.$t("sales.points-of-sale"), value: "pos" },
                {
                  title: this.$t("sales.points-of-sale-types"),
                  value: "pos_tipos",
                },
                { title: this.$t("sales.equipments"), value: "equipamentos" },
              ],
            },
            {
              title: this.$t("events.title"),
              value: "eventos",
              subtopics: [
                {
                  title: this.$t("events.event-config.create-edit"),
                  value: "eventos_gerenciar",
                },
                {
                  title: this.$t("events.categories.title"),
                  value: "categorias",
                },
                { title: this.$t("events.combos.title"), value: "combos" },
                {
                  title: this.$t("events.ordering.title"),
                  value: "ordenacao_eventos",
                },
              ],
            },
            {
              title: this.$t("sales.title"),
              value: "vendas",
              subtopics: [
                { title: this.$t("sales.manage"), value: "vendas_gerenciar" },
                {
                  title: this.$t("sales.discount-coupon.title"),
                  value: "cupons_desconto",
                },
                {
                  title:
                    this.$t("sales.ticket_package_title") ||
                    this.$t("sales.ticket-package.title"),
                  value: "envio_ingressos",
                },
                {
                  title: this.$t("sales.affiliates_program"),
                  value: "rede_afiliados",
                },
              ],
            },
            {
              title: this.$t("customers.title"),
              value: "clientes",
            },
            {
              title: "Check-in",
              value: "checkin",
            },
            {
              title: this.$t("financial.title"),
              value: "financeiro",
              subtopics: [
                {
                  title: this.$t("financial.regionals.title"),
                  value: "regional",
                },
                {
                  title: this.$t("financial.payment-methods.title"),
                  value: "formas_pagamento",
                },
              ],
            },
            {
              title: this.$t("people.title"),
              value: "pessoas",
              subtopics: [
                {
                  title: this.$t("people.users.eleven-admin"),
                  value: "usuario_eleven",
                },
                {
                  title: this.$t("people.affiliates.title"),
                  value: "afiliados",
                },
              ],
            },
            {
              title: this.$t("marketing.invitation.title"),
              value: "convite_email",
            },
            {
              title: this.$t("settings.title"),
              value: "configuracoes",
            },
            {
              title: this.$t("terms.title"),
              value: "termos",
            },
            {
              title: this.$t("help-center.eleven-access"),
              value: "eleven_access",
              subtopics: [
                {
                  title: this.$t("help-center.eleven-access-turnstile"),
                  value: "eleven_access_turnstile",
                },
                {
                  title: this.$t("help-center.eleven-access-facial"),
                  value: "eleven_access_facial",
                },
              ],
            },
            {
              title: this.$t("help-center.eleven-cashless"),
              value: "eleven_cashless",
            },
          ],
        },
        {
          title: this.$t("registrations.users.admin-producer"),
          active: this.isStoreKeeper ? true : false,
          user_type: "produtor",
          topics: [
            {
              title: this.$t("help-center.overview"),
              value: "visao_geral_produtor",
            },
            {
              title: "Dashboard",
              value: "dashboard_produtor",
            },
            {
              title: this.$t("digital-wallet.title"),
              value: "carteira_digital_produtor",
            },
            {
              title: this.$t("reports.title"),
              value: "relatorios_produtor",
            },
            {
              title: this.$t("sales.title"),
              value: "vendas_produtor",
              subtopics: [
                {
                  title: this.$t("sales.manage"),
                  value: "vendas_gerenciar_produtor",
                },
                {
                  title: this.$t("sales.discount-coupon.title"),
                  value: "cupons_desconto_produtor",
                },
                {
                  title:
                    this.$t("sales.ticket_package_title") ||
                    this.$t("sales.ticket-package.title"),
                  value: "envio_ingressos_produtor",
                },
                {
                  title: this.$t("events.combos.title"),
                  value: "combos_produtor",
                },
                {
                  title: this.$t("sales.affiliates_program"),
                  value: "rede_afiliados_produtor",
                },
              ],
            },
            {
              title: this.$t("events.title"),
              value: "eventos_produtor",
              subtopics: [
                {
                  title: this.$t("events.event-config.create-edit"),
                  value: "eventos_gerenciar_produtor",
                },
                {
                  title: this.$t("events.ordering.title"),
                  value: "ordenacao_eventos_produtor",
                },
              ],
            },
            {
              title: "Check-in",
              value: "checkin_produtor",
            },
            {
              title: this.$t("customers.title"),
              value: "clientes_produtor",
            },
            {
              title: this.$t("people.affiliates.title"),
              value: "afiliados_produtor",
            },
            {
              title: this.$t("registrations.users.title"),
              value: "usuarios_produtor",
            },
            {
              title: this.$t("registrations.integrations.title"),
              value: "integracoes_produtor",
            },
            {
              title: this.$t("marketing.invitation.title"),
              value: "convite_email_produtor",
            },
          ],
        },
        {
          title: this.$t("help-center.affiliate-admin"),
          active: this.isAffiliate ? true : false,
          value: "admin_afiliado",
          user_type: "afiliado",
          topics: [
            { title: "Dashboard", value: "dashboard_afiliado" },
            {
              title: this.$t("terms.acceptance-terms"),
              value: "termos_afiliado",
            },
            { title: "Ranking", value: "ranking_afiliado" },
          ],
        },
        {
          title: "POS",
          user_type: "produtor",
          topics: [
            {
              title: this.$t("help-center.overview"),
              value: "visao_geral_pos",
            },
            {
              title: this.$t("help-center.general-settings"),
              value: "config_gerais_pos",
              user_type: "admin",
            },
            {
              title: this.$t("help-center.login"),
              value: "login_pos",
            },
            {
              title: this.$t("events.title"),
              value: "eventos_pos",
            },
            {
              title: this.$t("help-center.payment"),
              value: "pagamento_pos",
            },
            {
              title: this.$t("help-center.courtesy"),
              value: "cortesia_pos",
            },
            {
              title: this.$t("help-center.history"),
              value: "historico_pos",
            },
            {
              title: this.$t("help-center.consult-cpf"),
              value: "consultar_cpf_pos",
            },
            {
              title: this.$t("help-center.cash-up-supply"),
              value: "suprimento_sangria_pos",
            },
            {
              title: this.$t("help-center.logout-sales-summary"),
              value: "resumo_vendas_pos",
            },
            {
              title: this.$t("help-center.help"),
              value: "ajuda_pos",
            },
          ],
        },
        {
          title: "App Check-In",
          user_type: "produtor",
          topics: [
            {
              title: this.$t("help-center.overview"),
              value: "visao_geral_checkin",
            },
            {
              title: this.$t("help-center.change-env"),
              value: "trocar_ambiente_checkin",
              user_type: "admin",
            },
            {
              title: this.$t("help-center.login"),
              value: "login_checkin",
            },
            {
              title: this.$t("help-center.recover-password"),
              value: "recuperar_senha_checkin",
            },
            {
              title: this.$t("help-center.sync"),
              value: "sincronizar_checkin",
            },
            {
              title: this.$t("help-center.configure-access"),
              value: "configurar_acessos_checkin",
            },
            {
              title: this.$t("help-center.read-qrcode"),
              value: "ler_qrcode_checkin",
            },
            {
              title: this.$t("help-center.consult-ticket"),
              value: "consultar_ticket_checkin",
            },
            {
              title: this.$t("help-center.consult-cpf"),
              value: "consultar_cpf_checkin",
            },
          ],
        },
      ];
    },
  },
};
